import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { getRedirectionPath } from 'localization/utils/getRedirectionPath';
import { FeatureFlags } from 'featureFlags/constants';
import { openLoginModal } from 'store/slice/accountModalSlice';
import { SECURE_ROUTES } from 'shared/enums/SecureRoutes';
import { startsWithStringInSet } from 'shared/utils/startsWithStringInSet';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { useStoreDispatch, useStoreSelector } from 'store/hooks/storeHooks';

const Login = () => {
  const storeDispatch = useStoreDispatch();
  const router = useRouter();
  const reserveEnabled = useFeatureFlag(FeatureFlags.TEMP_WEB_ENABLE_RESERVE_FLOW);

  const { isAuthenticated } = useStoreSelector((state) => state.auth);

  useEffect(() => {
    storeDispatch(openLoginModal());
  }, [storeDispatch]);

  useEffect(() => {
    const isDirectP = router?.asPath?.includes('productId');

    if (isAuthenticated && isDirectP && reserveEnabled) {
      const pId = router?.asPath?.split('=')[1]?.replace(/ \D /g, '');
      void router.replace(getRedirectionPath(`/products/${pId}`));
    }
  }, [isAuthenticated, router, reserveEnabled]);

  return <></>;
};

export const getServerSideProps = ({ query, locale }) => {
  const { redirect } = query;
  // ISI-47: protects against redirects to malicious websites
  const isAllowedRedirectUrl = redirect === '/' || startsWithStringInSet(SECURE_ROUTES, redirect);

  if (redirect && !isAllowedRedirectUrl) {
    return {
      redirect: { destination: getRedirectionPath('/', locale) },
    };
  }

  return { props: {} };
};

export default Login;
